<template>
  <span>
    <el-tooltip v-if="flow.status == '进行中' || (successPlus && flow.status == '审批通过')" class="item" effect="dark" content="取消该审批" placement="bottom">
      <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="cancelFlow()"></i>
    </el-tooltip>

    <!-- 取消流程弹窗 -->
    <div class="pop-room" v-if="cancleStatus">
      <a href="javascript:;" @click="cancleStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="取消原因：">
              <el-input size="small" v-model="form.remark" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="请输入取消审批的原因"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="cancelFlowSubmit()" class="form-btn" type="success">确认取消</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </span>
</template>

<script>
  import {
    mapState
  } from "vuex";

  export default {
    props: ['flow', 'successPlus'],
    data() {
      return {
        cancleStatus: "",
        form: {
          flowId: '',
          remark: '',
        }
      }
    },
    mounted() {},
    methods: {
      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post('/gc/project/flow/cancel', this.form, (res) => {
          this.$message.success("取消审批成功")
          this.$store.commit('set_projectReload', true)
          this.cancleStatus = false
          this.$emit('getLists')
        })
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = this.flow.id
        this.cancleStatus = true
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/CancelFlow.vue